import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Sidebar} from "primereact/sidebar";
import {TabView, TabPanel} from 'primereact/tabview';

import PurchaseorderrequestListComponent from "../../../components/2.0/purchaseorderrequest/PurchaseorderrequestListComponent";
import PurchaseorderrequestFormComponent from "../../../components/2.0/purchaseorderrequest/PurchaseorderrequestFormComponent";
import PurchaseorderFormComponent from "../../../components/2.0/purchaseorder/PurchaseorderFormComponent";
import PurchaseorderListComponent from "../../../components/2.0/purchaseorder/PurchaseorderListComponent";
import PurchaseorderShowComponent from "../../../components/2.0/purchaseorder/PurchaseorderShowComponent";
import ReceiptShowComponent from "../../../components/2.0/receipt/ReceiptShowComponent";
import ReceiptFormComponent from "../../../components/2.0/receipt/ReceiptFormComponent";
import PurchaseorderrequestShowComponent from "../../../components/2.0/purchaseorderrequest/PurchaseorderrequestShowComponent";
import PurchaseorderrequestImportComponent
  from "../../../components/2.0/purchaseorderrequest/PurchaseorderrequestImportComponent";

export const PurchaseDashboardPage = () => {

  useEffect(() => {
    window.App.pageHeight()
    document.title = 'Beszerzések' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('purchase')[0]) {
        document.getElementsByClassName('purchase')[0].classList.add("activeMenu")
      }
    }, 1000)
     if(
      document.getElementById('tabScroll')
      && document.getElementById('tabScroll').children
      && document.getElementById('tabScroll').children[0]
      && document.getElementById('tabScroll').children[0].querySelector("li:not(.p-disabled)").children[0]
    ) {
      document.getElementById('tabScroll').children[0].querySelector("li:not(.p-disabled)").children[0].click()
    }
  }, []);

  return (
    <div className="ModuleDashboardPage DashboardPage p-component p-p-3 ">
      {localStorage.getItem('module_purchase') ? (
        <>
          <div className={"p-grid p-d-flex p-flex-wrap"}>
            <div className={"p-col-12 p-lg-12 p-xl-12 p-p-0 left p-position-relative"}>
              <TabView renderActiveOnly="true" className={"nav"} scrollable={window.App.state.tabScroll} id="tabScroll">
                {localStorage.getItem('roles').toString().includes('role_purchase_order_req_read') ? (
                  <TabPanel header="Beszerzési  igény">
                    <div className={"p-px-2 p-pb-2"}>
                      <PurchaseorderrequestListComponent view="simple"/>
                    </div>
                  </TabPanel>
                ) : (
                  <TabPanel disabled></TabPanel>
                )}
                {localStorage.getItem('roles').toString().includes('role_purchase_order_read') ? (
                  <TabPanel header="Beszerzési megrendelések">
                    <div className={"p-px-2 p-pb-2"}>
                      <PurchaseorderListComponent view="simple"/>
                    </div>
                  </TabPanel>
                ) : (
                  <TabPanel disabled></TabPanel>
                )}
              </TabView>
            </div>
          </div>
          <Sidebar position="left" visible={window.App.state.sidebarPurchaseorderrequestCreate} closeOnEscape={true}
                   style={{width: '98%'}}
                   onHide={() => {
                     window.App.setState({sidebarPurchaseorderrequestCreate: false})
                   }}>
            <h2 className={"text-primary"}>Új beszerzési igény</h2>
            <PurchaseorderrequestFormComponent method="post"/>
          </Sidebar>
          <Sidebar position="left" visible={window.App.state.sidebarPurchaseorderrequestUpdate} closeOnEscape={true}
                   style={{width: '98%'}}
                   onHide={() => {
                     window.App.setState({sidebarPurchaseorderrequestUpdate: false})
                   }}>
            <h2 className={"text-primary"}>Beszerzési igény módosítása</h2>
            <PurchaseorderrequestFormComponent method="post" initialValues={window.App.state.props}/>
          </Sidebar>
          <Sidebar position="left" visible={window.App.state.sidebarPurchaseorderrequestShow} closeOnEscape={true}
                   style={{width: '740px'}}
                   onHide={() => {
                     window.App.setState({sidebarPurchaseorderrequestShow: false})
                   }}>
            {/*<h2 className={"text-primary"}>Beszerzési megrendelés igény megtekintése</h2>*/}
            <PurchaseorderrequestShowComponent initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarPurchaseorderCreate} closeOnEscape={true}
                   style={{width: '98%'}}
                   onHide={() => {
                     window.App.setState({sidebarPurchaseorderCreate: false})
                   }}>
            <h2 className={"text-primary"}>Új beszerzési megrendelés</h2>
            <PurchaseorderFormComponent method="post"/>
          </Sidebar>
          <Sidebar position="left" visible={window.App.state.sidebarPurchaseorderUpdate} closeOnEscape={true}
                   style={{width: '98%'}}
                   onHide={() => {
                     window.App.setState({sidebarPurchaseorderUpdate: false})
                   }}>
            <h2 className={"text-primary"}>Beszerzési megrendelés módosítása</h2>
            <PurchaseorderFormComponent method="post" initialValues={window.App.state.props}/>
          </Sidebar>
          <Sidebar position="left" visible={window.App.state.sidebarPurchaseorderShow} closeOnEscape={true}
                   style={{width: '98%'}}
                   onHide={() => {
                     window.App.setState({lazyparamsReceiptList: null})
                     window.App.setState({sidebarPurchaseorderShow: false})
                   }}>
            {/*<h2 className={"text-primary"}>Beszerzési megrendelés megtekintése</h2>*/}
            <PurchaseorderShowComponent initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarReceiptShow} closeOnEscape={true}
                   style={{width: '98%'}}
                   onHide={() => window.App.setState({
                     rerenderReceiptList: true,
                     sidebarReceiptShow: false,
                     newPartnerId: null,
                     newPartnerName: null
                   })}>
            <ReceiptShowComponent initialValues={window.App.state.props}/>
          </Sidebar>
          <Sidebar position="left" visible={window.App.state.sidebarReceiptUpdate} closeOnEscape={true}
                   style={{width: '98%'}}
                   onHide={() => window.App.setState({
                     rerenderReceiptList: true,
                     sidebarReceiptUpdate: false,
                     newPartnerId: null,
                     newPartnerName: null
                   })}>
            <h2 className={"text-primary"}>Költségszámla módosítása</h2>
            <ReceiptFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarPurchaseorderrequestImport} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarPurchaseorderrequestImport: false})
                   }}>
            <h2 className={"text-primary"}>Megrendelés igények importálása</h2>
            <PurchaseorderrequestImportComponent initialValues={window.App.state.props} method="post"/>
          </Sidebar>

        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
          Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
          <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;Előfizetői fiók áttekintése
                       </a>
                   </span>
          }
        </p>
      )}
    </div>
  )
}
export default withTranslation('common')(PurchaseDashboardPage);
